import {
  Paper,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { PrizeDto } from "../../models/Lottery";

interface IRunLotteryResultsProps {
  prizes: PrizeDto[];
  reRunLottery: any;
}
export const RunLotteryResults = ({
  prizes,
  reRunLottery,
}: IRunLotteryResultsProps) => {
  return (
    <Paper
      className="animate-bounce-in"
      sx={{
        p: 4,
        borderRadius: 4,
        border: "3px solid hsl(45, 90%, 50%)",
        background: "linear-gradient(135deg, hsl(45, 90%, 95%) 0%, white 100%)",
      }}
    >
      <Box sx={{ textAlign: "center", mb: 3 }}>
        <EmojiEventsIcon sx={{ fontSize: 64, color: "hsl(45, 90%, 50%)" }} />
        <Typography
          variant="h3"
          sx={{
            fontFamily: '"Mountains of Christmas", cursive',
            color: "hsl(150, 60%, 25%)",
          }}
        >
          🎉 Νικητές! 🎉
        </Typography>
      </Box>

      <List>
        {prizes.map((prize, index) => (
          <ListItem
            key={index}
            sx={{
              bgcolor:
                index % 2 === 0 ? "rgba(196, 30, 58, 0.05)" : "transparent",
              borderRadius: 2,
              mb: 1,
            }}
          >
            <ListItemIcon>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  bgcolor: "hsl(350, 80%, 40%)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: 700,
                }}
              >
                {index + 1}
              </Box>
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="h6" sx={{ color: "hsl(150, 60%, 25%)" }}>
                  {prize.winningTicketNumber}
                </Typography>
              }
              secondary={
                <Typography
                  sx={{ color: "hsl(45, 90%, 35%)", fontWeight: 600 }}
                >
                  🎁 {prize.name}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>

      {/* <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          variant="outlined"
          onClick={reRunLottery}
          sx={{
            borderColor: "hsl(350, 80%, 40%)",
            color: "hsl(350, 80%, 40%)",
            "&:hover": {
              borderColor: "hsl(350, 80%, 40%)",
              bgcolor: "rgba(196, 30, 58, 0.05)",
            },
          }}
        >
          Επαναληψη κληρωσης
        </Button>
      </Box> */}
    </Paper>
  );
};
